import { render, staticRenderFns } from "./DocumentResults.vue?vue&type=template&id=78e0a4f2&scoped=true"
import script from "./DocumentResults.vue?vue&type=script&lang=ts"
export * from "./DocumentResults.vue?vue&type=script&lang=ts"
import style0 from "./DocumentResults.vue?vue&type=style&index=0&id=78e0a4f2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e0a4f2",
  null
  
)

export default component.exports